import store from './store';
import { getDefaultConfig, ToastType } from './business';
import { loadComponent } from '@tencent/wphk-components-common/utils/load-component';
import Index from '../index.vue';

const cacheKey = Symbol('toast');
let timerId;

interface ToastOptions {
  /** css类名称 */
  className?: string;
  /** 是否展示 */
  show?: boolean;
  /** 图标类型 */
  type?: ToastType;
  /** 展示内容 */
  title?: string;
  /** toast大小 */
  size?: number;
  /** toast显示时间 */
  duration?: number;
  /** 是否自动关闭toast，默认自动 */
  isAutoHide?: boolean;
}

export function showToast(options: ToastOptions = { show: true }) {
  loadComponent(Index, cacheKey);
  const finalConfig = Object.assign(getDefaultConfig(), options, { show: true });
  Object.keys(finalConfig).forEach((key) => {
    if (typeof store.toast[key] !== 'undefined') {
      store.toast[key] = finalConfig[key];
    }
  });

  if (finalConfig.isAutoHide) {
    // 2s后隐藏
    timerId = setTimeout(() => {
      hideToast();
    }, finalConfig.duration || 2000);
  }
}

export function hideToast() {
  if (timerId) {
    clearTimeout(timerId);
    timerId = undefined;
  }
  store.toast.show = false;
}
